import React from "react"

import DetectiveClux from "../.."
import { HALLOWEEN_CONFIG } from "./config"

/** Atelier Détective Clux, implémentation « Mystère au château pour Halloween » */
const DetectiveCluxHalloween = () => <DetectiveClux config={HALLOWEEN_CONFIG} />

export default DetectiveCluxHalloween
